// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';

// actions.js
export const setCompanyUUID = (companyUUID) => ({
    type: 'user/SET_COMPANY_UUID',
    payload: companyUUID,
});

